const loadGlobalTemplates = ({ commit }, payload) => {
    commit('LOAD_GLOBAL_TEMPLATES', payload);
};

export default {
    loadGlobalTemplates,
};
